module.exports = __webpack_public_path__ + "static/img/85_chocolate.43467264.jpg";